export default __webpack_public_path__ + "static/Aleksey-Rybchak-78edd3e4b447af37096a1a54626a0c01.png";